import { Validators, ValidatorFn, AbstractControl } from "@angular/forms";

/** سكيمة كلمة المرور لتغيير الباسورد: 8–20 حرف، حرف كبير وصغير، رقم، حرف خاص، بدون مسافات */
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;

export const passwordValidators: ValidatorFn[] = [
  Validators.required,
  Validators.minLength(8),
  Validators.maxLength(20),
  (control: AbstractControl) => {
    const hasUppercase = /[A-Z]/.test(control.value);
    return hasUppercase ? null : { uppercase: true };
  },
  (control: AbstractControl) => {
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(control.value);
    return hasSpecialChar ? null : { specialChar: true };
  }
];

/** فاليديتورز مودال تغيير كلمة المرور: نفس السكيمة أعلاه + منع احتواء الباسورد على رقم الهاتف */
function getStoredPhoneForValidation(): string {
  try {
    return typeof sessionStorage !== 'undefined' ? (sessionStorage.getItem('mustChangePasswordPhone') || '') : '';
  } catch {
    return '';
  }
}

/** يتحقق أن كلمة المرور لا تحتوي على تسلسل رقم الهاتف (أرقام فقط) */
export function noPhoneInPasswordValidator(getPhone?: () => string): ValidatorFn {
  return (control: AbstractControl) => {
    const value = (control.value || '') as string;
    if (!value) return null;
    const phone = getPhone ? getPhone() : getStoredPhoneForValidation();
    const phoneDigits = phone.replace(/\D/g, '');
    if (phoneDigits.length < 4) return null;
    const passDigits = value.replace(/\D/g, '');
    if (passDigits.includes(phoneDigits)) return { containsPhone: true };
    if (phoneDigits.length >= 4 && phoneDigits.length <= value.length) {
      for (let len = 4; len <= phoneDigits.length; len++) {
        for (let i = 0; i <= phoneDigits.length - len; i++) {
          const segment = phoneDigits.slice(i, i + len);
          if (passDigits.includes(segment)) return { containsPhone: true };
        }
      }
    }
    return null;
  };
}

export const changePasswordValidators: ValidatorFn[] = [
  Validators.required,
  Validators.minLength(8),
  Validators.maxLength(20),
  (control: AbstractControl) => {
    const v = control.value;
    if (!v) return null;
    return PASSWORD_REGEX.test(v) ? null : { passwordPattern: true };
  },
  noPhoneInPasswordValidator()
];

const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWER = 'abcdefghjkmnpqrstuvwxyz';
const DIGITS = '23456789';
const SPECIAL = '!@#$%&*_+-=';
const ALL = UPPER + LOWER + DIGITS + SPECIAL;

/** يولد كلمة مرور قوية 12–16 حرفاً تطابق PASSWORD_REGEX. إن وُجد avoidDigits (أرقام الهاتف) يتجنب أي تسلسل 4+ منها. */
export function generateStrongPassword(avoidDigits?: string): string {
  const avoid = (avoidDigits || '').replace(/\D/g, '');
  const len = 12 + Math.floor(Math.random() * 5);
  const pick = (s: string) => s[Math.floor(Math.random() * s.length)];

  let pass = pick(UPPER) + pick(LOWER) + pick(DIGITS) + pick(SPECIAL);
  for (let i = pass.length; i < len; i++) {
    pass += pick(ALL);
  }
  pass = pass.split('').sort(() => Math.random() - 0.5).join('');

  if (avoid.length >= 4) {
    const passDigits = pass.replace(/\D/g, '');
    for (let len4 = 4; len4 <= avoid.length; len4++) {
      for (let i = 0; i <= avoid.length - len4; i++) {
        const segment = avoid.slice(i, i + len4);
        if (passDigits.includes(segment)) {
          return generateStrongPassword(avoidDigits);
        }
      }
    }
  }
  return pass;
}
